import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  daiLogo: {
    width: '80px',
    height: 'auto',
  },
  title: {
    textTransform: 'uppercase',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default styles
